import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mr-6 flex items-center gap-x-4 uppercase hover:text-black-600"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "flex items-center gap-x-4 border-t border-black-200 bg-white px-8 py-12 uppercase hover:bg-black-200" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: "text-black relative flex w-full max-w-fit cursor-pointer select-none items-center justify-between p-4 text-14 font-medium tracking-wider tablet:ml-0",
    onClick: _cache[0] || (_cache[0] = $event => ($data.showPicker = !$data.showPicker))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.availableStores, (store) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: store.name
      }, [
        ($data.domain.includes(`.${store.domain}`))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_icon, {
                icon: `flag-${store.domain}`,
                width: 20,
                height: 14
              }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(store.name), 1)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    _createVNode(_component_v_icon, {
      icon: "arrow-down",
      width: 12,
      height: 12,
      class: _normalizeClass(["linear transition-transform duration-200", $data.showPicker && 'rotate-180'])
    }, null, 8, ["class"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.showPicker)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["center-x text-black absolute w-auto border border-solid border-black-200 shadow-lg", $data.isMobile ? 'bottom-full' : 'top-full'])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.availableStores, (store) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: store.name,
                  href: `https://maniko-nails.${store.domain}` + $data.path + '?forcestay=true'
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_v_icon, {
                      icon: `flag-${store.domain}`,
                      width: 20,
                      height: 14
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(store.name), 1)
                  ])
                ], 8, _hoisted_2))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}